var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-box3"},[_c('div',{staticClass:"left-title"},[_vm._v("各年级体测成绩分布")]),_c('div',{staticClass:"echarts"},[_c('div',{style:({
        width: '830px',
        height: '274px',
        margin: '0 auto',
      }),attrs:{"id":"month"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }